import { Backdrop, CircularProgress, Dialog } from "@mui/material";
import {
  Check,
  ChevronLeft,
  ChevronRight,
  Clock,
  Edit,
  ExternalLink,
  X,
} from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { CalendarFill } from "react-bootstrap-icons";
import DatePicker from "react-datepicker";
import { Transition } from "../../controllers/Transition";
import API from "../../API/newIndex";
import { BardSvg } from "../../Assets/StaticData/BardSvg";
import { NOPHOTO_IMAGE } from "../../Assets/StaticData/StaticImage";
import { GenerateSlugName } from "../../controllers/GenerateSlugName";
import { clientData } from "../../controllers/GetClient";
import ImageUploader from "../../controllers/ImageUploader";
import { useRoutingByType } from "../../controllers/useRouting";
import { uploadTextEditorImage, scrollToFirstError } from "../../utilities/staticFunction";
import AiTextGenerate from "../AiTextGenerate";
import {
  ButtonComponent,
  InputComponent,
  SelectComponent,
  RichTextEditor
} from "@shopeasy-dashboard-ui/ui-library";
import Notification from "../Notification";
import useUnsavedChanges from "../../controllers/useUnsavedChanges";
import UnsavedChangesModal from "../../controllers/UnsavedChangesModal";
import { useUser } from "../../controllers/UserContext";
import { useAuthor } from "../../controllers/AuthorContext";
import UpdateCustomMetaField from "../../controllers/UpdateCustomMetaField";

const getChangedFields = (currentValues, originalValues) => {
  if (!currentValues || !originalValues) return currentValues || {};
  const changed = {};
  Object.keys(currentValues).forEach((key) => {
    const cur = currentValues[key];
    const orig = originalValues[key];
    if (JSON.stringify(cur) !== JSON.stringify(orig)) {
      changed[key] = cur;
    }
  });
  return changed;
};

const BulkEditBlog = ({
  isBulkEdit = true,
  bulkBlogIds = [],
  onClose,
  onSuccess,
}) => {
  const { userInfo, fetchUserInfo } = useUser();
  const { authorsList, fetchAuthors } = useAuthor();
  const [selectedAuthor, setSelectedAuthor] = useState("");

  useEffect(() => {
    if (!userInfo && typeof fetchUserInfo === "function") {
      fetchUserInfo();
    }
  }, [userInfo, fetchUserInfo]);

  const isCanSelectAuthor = useMemo(() => {
    if (!userInfo) return false;

    if (
      userInfo?.permissions === "all" ||
      userInfo?.data?.permissions === "all" ||
      userInfo?.is_admin === true ||
      userInfo?.is_owner === true
    ) {
      return true;
    }

    const getAllRoleStrings = (obj) => {
      if (!obj) return [];
      let results = [];
      if (typeof obj === "string") {
        results.push(obj);
      } else if (Array.isArray(obj)) {
        obj.forEach((item) => results.push(...getAllRoleStrings(item)));
      } else if (typeof obj === "object") {
        for (const key of Object.keys(obj)) {
          if (["role", "roles", "staff_role", "role_name", "type", "user_role"].includes(key)) {
            results.push(...getAllRoleStrings(obj[key]));
          }
        }
      }
      return results;
    };

    const allStrings = [
      ...getAllRoleStrings(userInfo),
      ...getAllRoleStrings(userInfo?.data),
      ...getAllRoleStrings(userInfo?.user),
    ].map((s) => String(s).toLowerCase().trim());

    return allStrings.some((str) => str.includes("admin") || str.includes("manager"));
  }, [userInfo]);

  useEffect(() => {
    if (isCanSelectAuthor) {
      fetchAuthors();
    }
  }, [isCanSelectAuthor, fetchAuthors]);

  const authorLabel = useMemo(() => {
    const translated = t("lang_Author");
    return translated && !translated.startsWith("lang_") ? translated : "Author";
  }, []);

  const authorPlaceholder = useMemo(() => {
    const translatedSelect = t("lang_select");
    const selectStr = translatedSelect && !translatedSelect.startsWith("lang_") ? translatedSelect : "Select";
    return `${selectStr} ${authorLabel}`;
  }, [authorLabel]);

  const [bulkBlogsList, setBulkBlogsList] = useState([]);
  const [activeBulkIndex, setActiveBulkIndex] = useState(0);
  const [blogSearchTerm, setBlogSearchTerm] = useState("");
  const bulkBlogsDataRef = useRef({});

  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [btnLoading, setBtnLoading] = useState(false);
  const [formSpinner, setFormSpinner] = useState(false);
  const [AiLoader, setAiloader] = useState(false);

  // Form State & Validation for Active Blog Item
  const [warn, setWarn] = useState(false);
  const [enableSlug, setEnableSlug] = useState(false);
  const slugInputRef = useRef(null);

  const [title, setTitle] = useState("");
  const [blogSlugName, setBlogSlugName] = useState("");
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [description, setDescription] = useState("");
  const [secondDescription, setSecondDescription] = useState("");
  const [image, setImage] = useState("");
  const [blogTagsArray, setBlogTagsArray] = useState([]);
  const [blogTagsValue, setBlogTagsValue] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("default");
  const [blogTemplateOptions, setBlogTemplateOptions] = useState([]);
  const [meta, setMeta] = useState({ meta_title: "", meta_description: "", meta_image: "" });
  const { meta_title, meta_description, meta_image } = meta;
  const [isMetaTitleCustom, setIsMetaTitleCustom] = useState(false);
  const [slugEdited, setSlugEdited] = useState(false);
  const [meta_fields, setmeta_fields] = useState({});
  const [isCustomField, setIsCustomField] = useState(false);
  const [customFieldList, setCustomFieldList] = useState([]);
  const [customFieldErrors, setCustomFieldErrors] = useState({});

  const originalDataRef = useRef(null);
  const originalPayloadRef = useRef(null);

  const [Category, setCategory] = useState([]);
  const [autocompleteSearch, setAutocompleteSearch] = useState();

  const [isSchedule, setIsSchedule] = useState(false);
  const [scheduleTimeDate, setScheduleTimeDate] = useState(null);

  const blogRoute = useRoutingByType("blog");
  const protocol = process.env.REACT_APP_ENVIRONMENT === "DEV" ? "http://" : "https://";
  const clientInfo = clientData;

  const buildPayload = (formData = {}) => {
    return {
      title: formData.title || "",
      blog_slug_name: formData.blogSlugName || "",
      blogcategory: Array.isArray(formData.selectedCategory)
        ? formData.selectedCategory.map((x) => x.id || x._id)
        : [],
      description: formData.description || "",
      second_description: formData.secondDescription || "",
      image: formData.image || "",
      blog_tags: formData.blogTagsArray || [],
      theme_template: formData.selectedTemplate || "default",
      user: formData.selectedAuthor || undefined,
      meta_title: formData.meta_title || "",
      meta_description: formData.meta_description || "",
      meta_image: formData.meta_image || "",
      custom_fields: formData.meta_fields || {},
      blog_publish_date: formData.scheduleTimeDate || undefined,
    };
  };

  const currentFormValues = useMemo(() => {
    return {
      title,
      blogSlugName,
      selectedCategory,
      description,
      secondDescription,
      image,
      blogTagsArray,
      selectedTemplate,
      selectedAuthor,
      meta_title,
      meta_description,
      meta_image,
      meta_fields,
      scheduleTimeDate,
    };
  }, [
    title,
    blogSlugName,
    selectedCategory,
    description,
    secondDescription,
    image,
    blogTagsArray,
    selectedTemplate,
    selectedAuthor,
    meta_title,
    meta_description,
    meta_image,
    meta_fields,
    scheduleTimeDate,
  ]);

  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const GetCategory = async (searchKey = "") => {
    setIsCategoryLoading(true);
    try {
      const data = await API({
        url: `/admin/blogcategory/GetBlogCategoriesWithParent`,
        method: "get",
        params: searchKey ? { searchkey: searchKey } : {},
      });
      if (data.status === 200 || data.status === 304) {
        const result = data?.data;
        setCategory(result?.data?.records || []);
      } else {
        setCategory([]);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategory([]);
    } finally {
      setIsCategoryLoading(false);
      setHasSearched(true);
    }
  };

  const getBlogTemplates = async () => {
    try {
      const res = await API({
        url: "/admin/themestore/getthemetemplates?type=blogs",
        method: "get",
      });
      if (res.status === 200 || res.status === 304) {
        setBlogTemplateOptions(res?.data?.templates || []);
      }
    } catch (error) {
      console.error("Error fetching theme templates:", error);
    }
  };

  const getMetaField = async () => {
    try {
      const ApiCall = await API({
        url: `/admin/metafieldgroup/getMetaFieldGroup/blog`,
        method: "get",
      });
      const result = ApiCall?.data;
      if (result?.data?.custom_fields?.length > 0) {
        setIsCustomField(true);
        setCustomFieldList(result?.data?.custom_fields || []);
      }
    } catch (error) {
      console.error("Error fetching custom fields:", error);
    }
  };

  useEffect(() => {
    GetCategory();
    getBlogTemplates();
    getMetaField();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (autocompleteSearch && autocompleteSearch.length >= 3) {
      const handler = setTimeout(() => {
        GetCategory(autocompleteSearch);
      }, 500);

      return () => {
        clearTimeout(handler);
      };
    } else {
      setIsCategoryLoading(false);
      setHasSearched(false);
    }
  }, [autocompleteSearch]);

  const categoryOptions = useMemo(() => {
    const records = Array.isArray(Category) ? Category : (Category?.data?.records || []);
    return records;
  }, [Category]);

  const filterOptionsForCategory = (options, state) => {
    const normalizedInputValue = state.inputValue?.toLowerCase();
    if (!normalizedInputValue || normalizedInputValue.length < 3) {
      return [];
    }
    return options.filter((option) => {
      const combinedFields = `${option?.parent_category?.toLowerCase() || ''} ${option?.blogcategory_name?.toLowerCase() || ''}`;
      return combinedFields.includes(normalizedInputValue);
    });
  };

  // Enrich selected category names when Category options load
  useEffect(() => {
    if (categoryOptions && categoryOptions.length > 0 && selectedCategory && selectedCategory.length > 0) {
      setSelectedCategory((prev) =>
        prev.map((cat) => {
          if (!cat.name || cat.name === cat.id) {
            const match = categoryOptions.find((c) => (c._id || c.id) === (cat.id || cat._id));
            if (match) {
              return {
                id: cat.id || cat._id,
                name: match.blogcategory_name || match.categoryName || (typeof match.parent_category === 'string' ? match.parent_category.split('>').pop().trim() : '') || "",
              };
            }
          }
          return cat;
        })
      );
    }
  }, [categoryOptions]);

  const handleBlogCategory = (id, name) => {
    if (id) {
      setSelectedCategory((prev) => {
        const exists = prev.some((x) => (x.id || x._id) === id);
        if (!exists) {
          return [...prev, { id, name }];
        }
        return prev;
      });
    }
  };

  const removeCategory = (id) => {
    setSelectedCategory((prev) => prev.filter((cat) => (cat.id || cat._id) !== id));
  };

  const parseCategoriesFromRaw = (rawCat) => {
    let initialCategories = [];
    if (Array.isArray(rawCat)) {
      initialCategories = rawCat.map((cat) => {
        if (typeof cat === "object" && cat !== null) {
          return {
            id: cat._id || cat.id,
            name: cat.blogcategory_name || cat.categoryName || cat.name || "",
          };
        }
        const match = categoryOptions?.find((c) => c._id === cat);
        return { id: cat, name: match?.blogcategory_name || match?.categoryName || "" };
      });
    } else if (rawCat) {
      if (typeof rawCat === "object" && rawCat !== null) {
        initialCategories = [
          {
            id: rawCat._id || rawCat.id,
            name: rawCat.blogcategory_name || rawCat.categoryName || rawCat.name || "",
          },
        ];
      } else {
        const match = categoryOptions?.find((c) => c._id === rawCat);
        initialCategories = [{ id: rawCat, name: match?.blogcategory_name || match?.categoryName || "" }];
      }
    }
    return initialCategories;
  };

  const applyBlogToForm = (rawBlog) => {
    if (!rawBlog) return;
    const initialCategories = parseCategoriesFromRaw(rawBlog?.blogcategory);
    const rawUser = rawBlog?.user;
    const authorId = typeof rawUser === "object" && rawUser !== null ? (rawUser._id || rawUser.id) : (rawUser || "");
    const initialPublishDate = rawBlog?.blog_publish_date ? new Date(rawBlog.blog_publish_date) : null;

    const initialFormValues = {
      title: rawBlog?.title || "",
      blogSlugName: rawBlog?.blog_slug_name || rawBlog?.slug || "",
      selectedCategory: initialCategories,
      description: rawBlog?.description || rawBlog?.second_description || "",
      secondDescription: rawBlog?.second_description || "",
      image: rawBlog?.image || "",
      blogTagsArray: Array.isArray(rawBlog?.blog_tags) ? rawBlog.blog_tags : Array.isArray(rawBlog?.tags) ? rawBlog.tags : [],
      selectedTemplate: rawBlog?.theme_template || "default",
      selectedAuthor: authorId,
      meta_title: rawBlog?.meta_title || "",
      meta_description: rawBlog?.meta_description || "",
      meta_image: rawBlog?.meta_image || "",
      meta_fields: rawBlog?.custom_fields || {},
      scheduleTimeDate: initialPublishDate,
    };

    originalDataRef.current = initialFormValues;
    originalPayloadRef.current = buildPayload(initialFormValues);

    setTitle(initialFormValues.title);
    setBlogSlugName(initialFormValues.blogSlugName);
    setSlugEdited(Boolean(initialFormValues.blogSlugName));
    setSelectedCategory(initialFormValues.selectedCategory);
    setDescription(initialFormValues.description);
    setSecondDescription(initialFormValues.secondDescription);
    setImage(initialFormValues.image);
    setBlogTagsArray(initialFormValues.blogTagsArray);
    setSelectedTemplate(initialFormValues.selectedTemplate);
    setSelectedAuthor(initialFormValues.selectedAuthor);
    setMeta({
      meta_title: initialFormValues.meta_title,
      meta_description: initialFormValues.meta_description,
      meta_image: initialFormValues.meta_image,
    });
    setIsMetaTitleCustom(Boolean(rawBlog?.meta_title));
    setmeta_fields(initialFormValues.meta_fields);
    setScheduleTimeDate(initialPublishDate);
    setCustomFieldErrors({});
    setEnableSlug(false);
    setWarn(false);
  };

  const fetchBlogsData = async () => {
    if (!bulkBlogIds || bulkBlogIds.length === 0) return;
    setFormSpinner(true);
    try {
      const res = await API({
        url: "/admin/blog/GetBlogDataByIds",
        method: "post",
        data: { blogs: bulkBlogIds, ids: bulkBlogIds },
      });

      let loadedRecords = [];
      if (res?.status === 200 || res?.status === 304) {
        const resultData = res?.data;
        loadedRecords =
          resultData?.data?.records ||
          resultData?.records ||
          (Array.isArray(resultData?.data) ? resultData.data : []) ||
          (Array.isArray(resultData) ? resultData : []);
      }

      if (loadedRecords.length > 0) {
        setBulkBlogsList(loadedRecords);
        applyBlogToForm(loadedRecords[0]);
      } else {
        setIsNotification(true);
        setNotificationMsg("No blog records found for bulk edit");
        setSeverity("error");
      }
    } catch (error) {
      console.error("Error fetching bulk blog data:", error);
      setIsNotification(true);
      setNotificationMsg(error?.message || "Failed to fetch blog details");
      setSeverity("error");
    } finally {
      setFormSpinner(false);
    }
  };

  useEffect(() => {
    fetchBlogsData();
  }, []);

  const switchActiveBlog = (newIndex) => {
    if (newIndex < 0 || newIndex >= bulkBlogsList.length) return;
    if (newIndex === activeBulkIndex) return;

    const currentBlog = bulkBlogsList[activeBulkIndex];
    if (currentBlog) {
      const currentPayload = buildPayload(currentFormValues);
      const baseline = originalPayloadRef.current || originalDataRef.current;
      const changed = baseline ? getChangedFields(currentPayload, baseline) : {};
      const isModified = Object.keys(changed).length > 0;

      bulkBlogsDataRef.current[currentBlog._id] = {
        values: { ...currentFormValues },
        original: originalDataRef.current,
        originalPayload: originalPayloadRef.current,
        isModified,
      };
    }

    setActiveBulkIndex(newIndex);
    const nextBlog = bulkBlogsList[newIndex];
    if (!nextBlog) return;

    const saved = bulkBlogsDataRef.current[nextBlog._id];
    if (saved) {
      originalDataRef.current = saved.original;
      originalPayloadRef.current = saved.originalPayload;

      setTitle(saved.values.title);
      setBlogSlugName(saved.values.blogSlugName);
      setSlugEdited(Boolean(saved.values.blogSlugName));
      setSelectedCategory(saved.values.selectedCategory || []);
      setDescription(saved.values.description);
      setSecondDescription(saved.values.secondDescription);
      setImage(saved.values.image);
      setBlogTagsArray(saved.values.blogTagsArray);
      setSelectedTemplate(saved.values.selectedTemplate || "default");
      setSelectedAuthor(saved.values.selectedAuthor || "");
      setMeta({
        meta_title: saved.values.meta_title,
        meta_description: saved.values.meta_description,
        meta_image: saved.values.meta_image,
      });
      setIsMetaTitleCustom(Boolean(saved ? saved.values.meta_title : nextBlog?.meta_title));
      setmeta_fields(saved.values.meta_fields || {});
      setScheduleTimeDate(saved.values.scheduleTimeDate || null);
      setCustomFieldErrors({});
      setEnableSlug(false);
      setWarn(false);
    } else {
      applyBlogToForm(nextBlog);
    }
  };

  const isBlogModified = (blog, index) => {
    if (!blog) return false;
    if (index === activeBulkIndex) {
      const currentPayload = buildPayload(currentFormValues);
      const baseline = originalPayloadRef.current || originalDataRef.current;
      const changed = baseline ? getChangedFields(currentPayload, baseline) : {};
      return Object.keys(changed).length > 0;
    }
    return Boolean(bulkBlogsDataRef.current[blog._id]?.isModified);
  };

  const modifiedCount = useMemo(() => {
    return bulkBlogsList.reduce((acc, blog, idx) => {
      return acc + (isBlogModified(blog, idx) ? 1 : 0);
    }, 0);
  }, [bulkBlogsList, activeBulkIndex, currentFormValues]);

  const resetAndClose = useCallback(() => {
    bulkBlogsDataRef.current = {};
    if (onClose) onClose();
  }, [onClose]);

  const {
    showUnsavedModal,
    handleRequestClose: handleBulkEditCancel,
    handleConfirmLeave,
    handleStay,
  } = useUnsavedChanges(modifiedCount > 0, resetAndClose);

  const activeBlogTitle = useMemo(() => {
    const active = bulkBlogsList[activeBulkIndex];
    return active?.title || "Blog";
  }, [bulkBlogsList, activeBulkIndex]);

  const filteredBlogsList = useMemo(() => {
    if (!blogSearchTerm || !blogSearchTerm.trim()) return bulkBlogsList;
    const term = blogSearchTerm.toLowerCase();
    return bulkBlogsList.filter((blog) => {
      const tName = (blog?.title || "").toLowerCase();
      const slug = (blog?.blog_slug_name || blog?.slug || "").toLowerCase();
      return tName.includes(term) || slug.includes(term);
    });
  }, [bulkBlogsList, blogSearchTerm]);

  const handleSlug = async (slug) => {
    if (slug?.length) {
      setBlogSlugName(await GenerateSlugName(slug));
    } else {
      setBlogSlugName("");
    }
  };

  const generateMetaData = async (data, key) => {
    const sourceContent = data || description || secondDescription || title;
    if (!sourceContent || sourceContent.trim().length === 0) {
      setIsNotification(true);
      setNotificationMsg("Please enter title or description first!");
      setSeverity("error");
      return;
    }
    try {
      setAiloader(true);
      const payload = { name: sourceContent };
      if (key === "description") {
        const ApiCall = await API({
          url: "/admin/ai/category_meta_description",
          method: "post",
          data: payload,
        });
        setMeta((prev) => ({
          ...prev,
          meta_description: ApiCall?.data?.data || "",
        }));
      } else {
        const ApiCall = await API({
          url: "/admin/ai/category_meta_title",
          method: "post",
          data: payload,
        });
        setIsMetaTitleCustom(true);
        setMeta((prev) => ({
          ...prev,
          meta_title: ApiCall?.data?.data || "",
        }));
      }
    } catch (error) {
      if (error?.response?.status === 429) {
        setIsNotification(true);
        setNotificationMsg(t("lang_Hit_chatgpt_limit") || "ChatGPT limit reached");
        setSeverity("warning");
      } else {
        setIsNotification(true);
        setNotificationMsg(error?.response?.data?.message || "Failed to generate metadata");
        setSeverity("error");
      }
    } finally {
      setAiloader(false);
    }
  };

  const handleBulkUpdate = async () => {
    // Validate current active blog
    if (!title || !title.trim()) {
      setWarn(true);
      setIsNotification(true);
      setNotificationMsg("Blog Title is required!");
      setSeverity("error");
      scrollToFirstError("title");
      return;
    }

    // Validate custom fields for active blog
    if (isCustomField && customFieldList?.length > 0) {
      const cfErrors = {};
      for (const field of customFieldList) {
        const isRequired = Boolean(
          field?.is_required === true || field?.is_required === 1 || field?.required === true
        );
        if (isRequired) {
          const val = meta_fields?.[field.custom_field_name];
          if (val === undefined || val === null || (typeof val === "string" && val.trim() === "")) {
            cfErrors[field.custom_field_name] = `${field.custom_field_name} is required!`;
          }
        }
      }
      if (Object.keys(cfErrors).length > 0) {
        setCustomFieldErrors(cfErrors);
        setIsNotification(true);
        setSeverity("warning");
        const firstErrorField = Object.keys(cfErrors)[0];
        setNotificationMsg(`${firstErrorField} is required!`);
        scrollToFirstError(firstErrorField);
        return;
      }
    }

    try {
      setBtnLoading(true);
      setFormSpinner(true);

      const currentBlog = bulkBlogsList[activeBulkIndex];
      if (currentBlog) {
        const currentPayload = buildPayload(currentFormValues);
        const baseline = originalPayloadRef.current || originalDataRef.current;
        const changed = baseline ? getChangedFields(currentPayload, baseline) : {};
        const isModified = Object.keys(changed).length > 0;

        bulkBlogsDataRef.current[currentBlog._id] = {
          values: { ...currentFormValues },
          original: originalDataRef.current,
          originalPayload: originalPayloadRef.current,
          isModified,
        };
      }

      const modifiedEntries = Object.entries(bulkBlogsDataRef.current).filter(
        ([_, data]) => data?.isModified
      );

      if (modifiedEntries.length === 0) {
        setIsNotification(true);
        setNotificationMsg("No changes detected to update");
        setSeverity("info");
        setBtnLoading(false);
        setFormSpinner(false);
        return;
      }

      // Check validation for all modified items
      for (const [blogId, data] of modifiedEntries) {
        if (!data.values.title || !data.values.title.trim()) {
          setIsNotification(true);
          setNotificationMsg("All modified blogs must have a Title");
          setSeverity("error");
          setBtnLoading(false);
          setFormSpinner(false);
          return;
        }
        if (isCustomField && customFieldList?.length > 0) {
          for (const field of customFieldList) {
            const isRequired = Boolean(
              field?.is_required === true || field?.is_required === 1 || field?.required === true
            );
            if (isRequired) {
              const val = data.values.meta_fields?.[field.custom_field_name];
              if (val === undefined || val === null || (typeof val === "string" && val.trim() === "")) {
                setIsNotification(true);
                setNotificationMsg(`Blog "${data.values.title || 'Blog'}" is missing required custom field: ${field.custom_field_name}!`);
                setSeverity("warning");
                setBtnLoading(false);
                setFormSpinner(false);
                return;
              }
            }
          }
        }
      }

      const bulkPayload = modifiedEntries
        .map(([blogId, data]) => {
          const payload = buildPayload(data.values);
          const baseline = data.originalPayload || data.original;
          const changed = getChangedFields(payload, baseline);

          const fieldsToUpdate = changed && Object.keys(changed).length > 0 ? changed : payload;

          return {
            _id: blogId,
            id: blogId,
            data: fieldsToUpdate,
            ...fieldsToUpdate,
          };
        })
        .filter(Boolean);

      if (bulkPayload.length === 0) {
        setIsNotification(true);
        setNotificationMsg("No changes detected to update");
        setSeverity("info");
        setBtnLoading(false);
        setFormSpinner(false);
        return;
      }

      const res = await API({
        url: "/admin/blog/BulkUpdateBlog",
        method: "post",
        data: bulkPayload,
      });

      if (res.status === 200 || res.status === 304) {
        setIsNotification(true);
        setNotificationMsg(
          `${bulkPayload.length} blog${bulkPayload.length > 1 ? "s" : ""} updated successfully!`
        );
        setSeverity("success");
        bulkBlogsDataRef.current = {};
        if (onSuccess) {
          onSuccess(bulkPayload.length);
        }
      } else {
        throw new Error(res?.data?.message || "Failed to update blogs");
      }
    } catch (error) {
      console.error("Error bulk updating blogs:", error);
      setIsNotification(true);
      setNotificationMsg(error?.message || error || "Failed to update blogs");
      setSeverity("error");
    } finally {
      setBtnLoading(false);
      setFormSpinner(false);
    }
  };

  const saveBlogTagsValue = () => {
    if (blogTagsValue.length > 0) {
      if (blogTagsValue.includes(",")) {
        let tagSeperator = blogTagsValue.split(",");
        let finalArray = [];
        let blogTags = [...blogTagsArray, ...tagSeperator];
        blogTags.forEach((tag) => {
          const searchRegex = new RegExp(`^${tag.trim()}$`, "i");
          let exists = finalArray.some((finalTag) => searchRegex.test(finalTag));
          if (!exists) {
            finalArray.push(tag.trim());
          }
        });
        setBlogTagsArray(finalArray);
      } else {
        const searchRegex = new RegExp(`^${blogTagsValue}$`, "i");
        const exists = blogTagsArray.some((tag) => searchRegex.test(tag));
        if (!exists) {
          setBlogTagsArray((prev) => [...prev, blogTagsValue.trim()]);
        }
      }
      setBlogTagsValue("");
    }
  };

  const removeTag = (index) => {
    setBlogTagsArray((prev) => prev.filter((_, idx) => idx !== index));
  };

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  const wordCount = (description || "")
    .replace(/<[^>]*>/g, " ")
    .split(/\s+/)
    .filter(Boolean).length;

  const metaDescLength = (meta_description || "").replace(/<[^>]+>/g, "").length;

  return (
    <div className="flex flex-col h-screen w-screen overflow-hidden bg-gray-100 dark:bg-zinc-950 text-gray-900 dark:text-zinc-100">
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      {(formSpinner || AiLoader) && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={formSpinner || AiLoader}
          className="flex flex-col"
        >
          <CircularProgress color="inherit" />
          <p className="mt-2 text-sm">
            {AiLoader ? t("lang_ai_generate_content_loader") || "Generating content..." : t("lang_loading") || "Processing..."}
          </p>
        </Backdrop>
      )}

      {/* Top Header Bar */}
      <div className="flex items-center justify-between px-6 py-3.5 border-b border-gray-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 shrink-0">
        <div className="flex items-center space-x-3">
          <button
            type="button"
            onClick={handleBulkEditCancel}
            className="w-7 h-7 rounded-full flex items-center justify-center text-gray-500 dark:text-zinc-400 hover:bg-gray-100 dark:hover:bg-zinc-800 hover:text-gray-900 dark:hover:text-white transition-colors cursor-pointer"
          >
            <X size={18} />
          </button>
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <h5 className="text-sm font-bold text-gray-900 dark:text-white m-0">
                Bulk Edit Blogs
              </h5>
              <span className="bg-gray-100 dark:bg-zinc-800 text-gray-600 dark:text-zinc-300 text-[11px] font-semibold px-2 py-0.5 rounded-full">
                {bulkBlogsList.length} Selected
              </span>
            </div>
            <p className="text-[11px] text-gray-500 dark:text-zinc-400 m-0 mt-0.5">
              Select any blog from the list to view and edit its details.
            </p>
          </div>
        </div>
      </div>

      {/* Main Body */}
      <div className="flex flex-1 min-h-0 overflow-hidden">
        {/* Left Sidebar Panel */}
        <div className="w-[300px] border-r border-gray-200 dark:border-zinc-800 bg-gray-50 dark:bg-zinc-950 p-4 flex flex-col shrink-0">
          {/* Outer Rounded Container matching Reference */}
          <div className="flex-1 flex flex-col border border-gray-200 dark:border-zinc-800 rounded-2xl bg-white dark:bg-zinc-900 overflow-hidden shadow-xs">
            {/* Header section */}
            <div className="p-3.5 border-b border-gray-200 dark:border-zinc-800 flex items-center justify-between">
              <span className="text-xs font-bold text-gray-900 dark:text-white">
                Selected Blogs
              </span>
              <div className="flex items-center space-x-1 text-xs text-gray-500 dark:text-zinc-400">
                <button
                  type="button"
                  disabled={activeBulkIndex === 0}
                  onClick={() => switchActiveBlog(activeBulkIndex - 1)}
                  className="p-1 rounded hover:bg-gray-100 dark:hover:bg-zinc-800 disabled:opacity-30 disabled:pointer-events-none cursor-pointer text-gray-600 dark:text-zinc-400"
                >
                  <ChevronLeft size={14} />
                </button>
                <span className="font-mono text-[11px] text-gray-600 dark:text-zinc-400">
                  {activeBulkIndex + 1}/{bulkBlogsList.length}
                </span>
                <button
                  type="button"
                  disabled={activeBulkIndex === bulkBlogsList.length - 1}
                  onClick={() => switchActiveBlog(activeBulkIndex + 1)}
                  className="p-1 rounded hover:bg-gray-100 dark:hover:bg-zinc-800 disabled:opacity-30 disabled:pointer-events-none cursor-pointer text-gray-600 dark:text-zinc-400"
                >
                  <ChevronRight size={14} />
                </button>
              </div>
            </div>

            {/* Filter Search Input Section */}
            <div className="p-3 border-b border-gray-200 dark:border-zinc-800 bg-transparent">
              <input
                type="text"
                placeholder="Filter selected blogs..."
                value={blogSearchTerm}
                onChange={(e) => setBlogSearchTerm(e.target.value)}
                className="w-full px-3 py-1.5 text-xs border border-gray-200 dark:border-zinc-700/80 rounded-lg bg-white dark:bg-zinc-800/80 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-zinc-400 focus:outline-none shadow-xs"
              />
            </div>

            {/* Items List flush inside container with clean dark borders */}
            <div className="flex-1 overflow-y-auto custom-scrollbar">
              {filteredBlogsList.map((blog) => {
                const actualIndex = bulkBlogsList.findIndex((item) => item._id === blog._id);
                const isActive = actualIndex === activeBulkIndex;
                const isModified = isBlogModified(blog, actualIndex);

                return (
                  <div
                    key={blog._id}
                    onClick={() => switchActiveBlog(actualIndex)}
                    className={`p-3 cursor-pointer transition-colors flex items-center justify-between gap-3 border-b border-gray-200 dark:border-zinc-800 last:border-b-0 ${isActive
                      ? "bg-gray-100 dark:bg-zinc-800/90"
                      : "bg-white dark:bg-zinc-900 hover:bg-gray-100 dark:hover:bg-zinc-800/60"
                      }`}
                  >
                    <div className="flex items-center space-x-3 min-w-0 flex-1">
                      <div className="w-10 h-10 rounded-md bg-gray-50 dark:bg-zinc-800 border border-gray-200 dark:border-zinc-700/80 flex items-center justify-center shrink-0 overflow-hidden p-1">
                        <img
                          src={blog?.image || blog?.meta_image || NOPHOTO_IMAGE}
                          onError={(e) => {
                            e.target.src = NOPHOTO_IMAGE;
                          }}
                          className="w-full h-full object-contain"
                          alt=""
                        />
                      </div>
                      <div className="flex flex-col min-w-0 flex-1">
                        <span className={`text-xs truncate ${isActive ? "font-bold text-gray-900 dark:text-white" : "font-medium text-gray-800 dark:text-zinc-200"}`}>
                          {blog?.title || "-"}
                        </span>
                        <span className="text-[11px] text-gray-400 dark:text-zinc-400 truncate mt-0.5">
                          Single
                        </span>
                      </div>
                    </div>

                    {isModified && (
                      <span
                        title='Modified'
                        className={`w-2 h-2 rounded-full bg-amber-500 shrink-0 select-none inline-block`}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Right Main Form Content Area */}
        <div className="flex-1 flex flex-col min-h-0 overflow-hidden bg-gray-100 dark:bg-zinc-950">
          {/* Right Sub-Header Bar */}
          <div className="flex items-center justify-between px-6 py-2.5 bg-white dark:bg-zinc-900 border-b border-gray-200 dark:border-zinc-800 text-xs shrink-0">
            <div>
              <span className="font-bold text-gray-900 dark:text-white">
                Currently Editing: {activeBlogTitle}
              </span>{" "}
              <span className="text-gray-400 dark:text-zinc-500 font-mono text-[11px]">
                ({activeBulkIndex + 1} of {bulkBlogsList.length})
              </span>
            </div>
            <div>
              {modifiedCount > 0 ? (
                <span className="text-emerald-600 dark:text-emerald-400 font-medium text-xs">
                  {modifiedCount} blog modified
                </span>
              ) : (
                <span className="text-gray-400 dark:text-zinc-500 text-xs font-normal">No unsaved changes</span>
              )}
            </div>
          </div>

          {/* Form Area matching AddBlog.js field sequence & card stack */}
          <div className="flex-1 overflow-y-auto p-6 custom-scrollbar">
            <form
              onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
              className="max-w-4xl mx-auto space-y-5"
            >
              {/* Card 1: Main Details */}
              <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-2xl p-6 shadow-xs space-y-4">
                {/* Blog Title * */}
                <div>
                  <label htmlFor="title">
                    <p className="text-xs font-semibold text-gray-700 dark:text-zinc-300 mb-1">
                      {t("lang_Blog_Title") || "Blog Title"} <span className="text-red-500">*</span>
                    </p>
                  </label>
                  <InputComponent
                    className={warn ? "border-red-500" : ""}
                    type="text"
                    id="title"
                    name="title"
                    value={title}
                    onChange={(e) => {
                      const val = e.target.value;
                      setTitle(val);
                      setWarn(false);
                      if (!enableSlug && (!slugEdited || !blogSlugName)) handleSlug(val);
                      if (!isMetaTitleCustom) {
                        setMeta((prev) => ({ ...prev, meta_title: val }));
                      }
                    }}
                    onBlur={() => {
                      if (!enableSlug && (!slugEdited || !blogSlugName) && title) handleSlug(title);
                      if (!isMetaTitleCustom && !meta_title && title) {
                        setMeta((prev) => ({ ...prev, meta_title: title }));
                      }
                    }}
                    placeholder="e.g. Blog about your latest products or deals"
                  />

                  {/* Slug Inline Edit & Preview Bar */}
                  <div className="flex items-center justify-between mt-1 text-xs text-gray-500 dark:text-zinc-400 w-full gap-1 min-h-[24px]">
                    <div className="flex items-center w-[90%] min-w-0">
                      <a
                        href={`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${blogRoute}/${(blogSlugName || "").toLowerCase()}`}
                        target="_blank"
                        rel="noreferrer"
                        className="font-medium shrink-0 mr-2 hover:underline cursor-pointer text-blue-600 dark:text-blue-400 flex items-center text-[11px]"
                      >
                        Preview
                        <ExternalLink size={12} className="ml-0.5" />
                      </a>
                      {!enableSlug ? (
                        <div className="flex items-center gap-2 min-w-0 text-[11px]">
                          <span className="truncate text-gray-500 dark:text-zinc-400 min-w-0">
                            {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${blogRoute}/${(blogSlugName || "").toLowerCase()}`}
                          </span>
                          <button
                            type="button"
                            onClick={() => {
                              setEnableSlug(true);
                              setTimeout(() => slugInputRef.current?.focus(), 50);
                            }}
                            className="text-gray-600 hover:text-black dark:text-zinc-400 dark:hover:text-white shrink-0 flex items-center cursor-pointer"
                          >
                            <Edit size={14} />
                          </button>
                        </div>
                      ) : (
                        <div className="flex items-center gap-1 min-w-0 flex-1 text-[11px]">
                          <span className="text-gray-400 dark:text-zinc-500 shrink truncate max-w-[120px] sm:max-w-[200px]">
                            {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${blogRoute}/`}
                          </span>
                          <InputComponent
                            ref={slugInputRef}
                            name="blog_slug_name"
                            className="flex-1 min-w-[60px] !h-[22px] !py-0.5 !px-1 text-xs"
                            value={blogSlugName || ""}
                            onChange={(e) => {
                              setBlogSlugName(e.target.value);
                              setSlugEdited(Boolean(e.target.value));
                            }}
                            onBlur={async () => {
                              if (blogSlugName) {
                                const generated = await GenerateSlugName(blogSlugName);
                                setBlogSlugName(generated);
                              }
                            }}
                            onKeyDown={async (e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                if (!blogSlugName) {
                                  setIsNotification(true);
                                  setSeverity("warning");
                                  setNotificationMsg("Slug cannot be empty!");
                                  return;
                                }
                                const generated = await GenerateSlugName(blogSlugName);
                                setBlogSlugName(generated);
                                setEnableSlug(false);
                                setSlugEdited(true);
                              }
                            }}
                            isSlug={true}
                          />
                          <button
                            type="button"
                            className="text-green-600 dark:text-green-400 ml-1 shrink-0 flex items-center cursor-pointer"
                            onClick={async () => {
                              if (!blogSlugName) {
                                setIsNotification(true);
                                setSeverity("warning");
                                setNotificationMsg("Slug cannot be empty!");
                                return;
                              }
                              const generated = await GenerateSlugName(blogSlugName);
                              setBlogSlugName(generated);
                              setEnableSlug(false);
                              setSlugEdited(true);
                            }}
                          >
                            <Check size={14} />
                          </button>
                        </div>
                      )}
                    </div>

                    <span
                      className={`shrink-0 text-end text-[11px] ${(title?.length || 0) > 60 ? "text-red-500 font-semibold" : "text-gray-400 dark:text-zinc-500"
                        }`}
                    >
                      {title?.length || 0}/60
                    </span>
                  </div>

                  {warn && (
                    <p className="text-red-500 text-xs mt-1">{t("lang_Please_Enter_Blog_Title") || "Please enter Blog Title"}</p>
                  )}
                </div>

                {/* Blog Category */}
                <div>
                  <label htmlFor="blogcategory" className="text-xs font-semibold text-gray-700 dark:text-zinc-300 mb-1 block">
                    {t("lang_Blog_Category") || "Blog Category"}
                  </label>
                  <SelectComponent
                    className="autocomplete"
                    options={categoryOptions}
                    getOptionLabel={(option) => {
                      if (!option) return "";
                      if (typeof option === "string") return option;
                      return (
                        option?.blogcategory_name ||
                        option?.categoryName ||
                        (typeof option?.parent_category === "string"
                          ? option.parent_category.split(">").pop().trim()
                          : "") ||
                        ""
                      );
                    }}
                    getOptionValue={(option) => option?._id}
                    filterOptions={filterOptionsForCategory}
                    onInputChange={(newInputValue) => {
                      if (typeof newInputValue === "string" && newInputValue?.length >= 3) {
                        setHasSearched(false);
                        setAutocompleteSearch(newInputValue);
                      } else {
                        setIsCategoryLoading(false);
                        setHasSearched(false);
                        setAutocompleteSearch("");
                      }
                    }}
                    noOptionsText={
                      isCategoryLoading
                        ? `${t("lang_loading") || "Loading"}...`
                        : !autocompleteSearch || autocompleteSearch.length < 3 || !hasSearched
                          ? t("lang_enter_three_characters") || "Please enter at least 3 characters to search"
                          : t("lang_no_option_found") || "No options found"
                    }
                    onChange={(e, v) => {
                      const selectedCat =
                        typeof v === "object" && v !== null
                          ? v
                          : categoryOptions?.find((cat) => cat._id === (e?.target?.value || v));
                      if (selectedCat) {
                        handleBlogCategory(
                          selectedCat._id,
                          selectedCat.blogcategory_name ||
                          selectedCat.categoryName ||
                          (typeof selectedCat.parent_category === "string"
                            ? selectedCat.parent_category.split(">").pop().trim()
                            : "")
                        );
                      }
                    }}
                    placeholder={`${t("lang_select") || "Select"} ${t("lang_category") || "Category"}`}
                    tabIndex={2}
                  />

                  {/* Selected Categories Tag Pills */}
                  {selectedCategory && selectedCategory.length > 0 && (
                    <div className="flex flex-wrap items-center mt-2 gap-1.5">
                      {selectedCategory.map((elem) => (
                        <div
                          key={elem.id || elem._id}
                          className="bg-gray-100 dark:bg-zinc-800 border border-gray-200 dark:border-zinc-700 text-gray-800 dark:text-zinc-200 flex items-center me-1 mb-1 text-xs px-2.5 py-1 rounded-md"
                        >
                          <span className="font-medium text-xs truncate max-w-[180px]">{elem.name}</span>
                          <X
                            className="h-[14px] w-[14px] text-red-500 hover:text-red-700 ms-1.5 cursor-pointer shrink-0"
                            onClick={() => removeCategory(elem?.id || elem?._id)}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Blog Description */}
                <div>
                  <label htmlFor="description" className="text-xs font-semibold text-gray-700 dark:text-zinc-300 mb-1 block">
                    {t("lang_Blog_Description") || "Blog Description"}
                  </label>
                  <RichTextEditor
                    htmlData={description}
                    setHtmlData={(val) => setDescription(val)}
                    uplaodImageFile={uploadTextEditorImage}
                  />
                  <div className="flex w-full justify-end mt-1">
                    <p
                      className={`text-[11px] ${wordCount > 280 ? "text-red-500 font-semibold" : "text-gray-400 dark:text-zinc-500"
                        }`}
                    >
                      {wordCount}/280 words
                    </p>
                  </div>
                </div>

                {/* Blog Tags */}
                <div>
                  <label htmlFor="tags" className="text-xs font-semibold text-gray-700 dark:text-zinc-300 mb-1 block">
                    {t("lang_Blog_Tags") || "Blog Tags"}
                  </label>
                  <InputComponent
                    type="text"
                    id="tags"
                    value={blogTagsValue}
                    onChange={(e) => setBlogTagsValue(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        saveBlogTagsValue();
                      }
                    }}
                    placeholder="e.g. Black"
                  />
                  <p className="w-full text-[11px] mt-1 text-gray-400 dark:text-zinc-500">
                    Use <b className="text-gray-700 dark:text-zinc-300">Enter</b> key to separate tags
                  </p>

                  {blogTagsArray.length > 0 && (
                    <div className="flex flex-wrap gap-1.5 mt-2.5">
                      {blogTagsArray.map((tag, idx) => (
                        <span
                          key={idx}
                          className="inline-flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-full bg-gray-100 dark:bg-zinc-800 text-gray-800 dark:text-zinc-200 font-medium"
                        >
                          {tag}
                          <button
                            type="button"
                            onClick={() => removeTag(idx)}
                            className="hover:text-red-500 transition-colors cursor-pointer"
                          >
                            <X size={12} />
                          </button>
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                {/* Author Select */}
                {isCanSelectAuthor && (
                  <div>
                    <label htmlFor="selectedAuthor" className="text-xs font-semibold text-gray-700 dark:text-zinc-300 mb-1 block">
                      {authorLabel}
                    </label>
                    <SelectComponent
                      value={selectedAuthor || ""}
                      onChange={(e, v) => {
                        const val = e?.target?.value !== undefined ? e.target.value : (typeof v === "object" && v !== null ? (v.value || v._id || v.user_id || v.id) : (v || ""));
                        setSelectedAuthor(val);
                      }}
                      options={authorsList?.map((item) => ({
                        value: item._id || item.user_id || item.id,
                        label: item.name || `${item.first_name || ""} ${item.last_name || ""}`.trim() || item.email,
                      }))}
                      placeholder={authorPlaceholder}
                    />
                  </div>
                )}

                {/* Theme Template */}
                <div>
                  <label htmlFor="selectedTemplate" className="text-xs font-semibold text-gray-700 dark:text-zinc-300 mb-1 block">
                    Theme Template
                  </label>
                  <SelectComponent
                    id="selectedTemplate"
                    value={selectedTemplate || "default"}
                    onChange={(e, v) => {
                      const val = e?.target?.value !== undefined ? e.target.value : (typeof v === "object" && v !== null ? (v.value || v) : (v || "default"));
                      setSelectedTemplate(val);
                    }}
                    options={
                      blogTemplateOptions.length > 0
                        ? blogTemplateOptions.map((item) => ({ value: item, label: item }))
                        : [{ value: "default", label: "default" }]
                    }
                  />
                </div>

                {/* Publish Date */}
                <div>
                  <label className="text-xs font-semibold text-gray-700 dark:text-zinc-300 mb-1 block">
                    {t("lang_Publish_Date") || "Publish Date"}
                  </label>
                  {scheduleTimeDate ? (
                    <div className="flex items-center gap-3">
                      <ButtonComponent
                        variant="outline"
                        type="button"
                        onClick={() => setIsSchedule(true)}
                      >
                        {t("lang_Update_Publish_Date") || "Update publish date"}
                      </ButtonComponent>
                      <div className="flex items-center justify-between px-3 py-2 bg-[#f8fafc] dark:bg-zinc-800/60 border border-gray-200 dark:border-zinc-700 rounded-lg flex-1">
                        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                          {new Date(scheduleTimeDate).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: false,
                          })}
                        </span>
                        <button
                          type="button"
                          className="text-red-500 hover:text-red-600 text-sm font-normal bg-transparent border-none p-0 cursor-pointer ml-3"
                          onClick={() => setScheduleTimeDate(null)}
                        >
                          {t("lang_Clear") || "Clear"}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center gap-3">
                      <ButtonComponent
                        variant="outline"
                        type="button"
                        onClick={() => setIsSchedule(true)}
                      >
                        {t("lang_Set_Publish_Date") || "Set publish date"}
                      </ButtonComponent>
                    </div>
                  )}
                </div>
              </div>

              {/* Card 2: Media * */}
              <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-2xl p-6 shadow-xs space-y-4">
                <div className="flex items-center justify-between mb-1">
                  <h6 className="text-xs font-bold text-gray-900 dark:text-white m-0">
                    {t("lang_media") || "Media"} <span className="text-red-500">*</span>
                  </h6>
                  <span className="inline-flex items-center cursor-pointer hover:underline text-xs text-blue-600 dark:text-blue-400 font-medium gap-1">
                    <BardSvg /> {t("lang_generate_image") || "Generate Image"}
                  </span>
                </div>
                <p className="text-[11px] text-gray-400 dark:text-zinc-400 m-0 mb-3">
                  {t("lang_Upload_Captivating_Image_To_Make_Your_Blog_Stand_Out") || "Upload captivating image to make your blog stand out"}
                </p>

                <div className="w-full mb-2">
                  <ImageUploader
                    alreadyImage={image}
                    handleSetImage={(value) => setImage(value)}
                    folder="blog"
                    format="image"
                    removeImages={() => setImage("")}
                  />
                </div>
              </div>

              {/* Card 3: Search Engine Listing */}
              <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-2xl p-6 shadow-xs space-y-4">
                <h6 className="text-xs font-bold text-gray-900 dark:text-white m-0">
                  {t("lang_search_engine_listing") || "Search Engine Listing"}
                </h6>

                {/* Live Google Snippet Preview Box */}
                <div className="w-full">
                  {meta_title?.length > 0 ? (
                    <div className="w-full bg-white dark:bg-zinc-800 border border-gray-200 dark:border-zinc-700 rounded-xl shadow-xs p-4 text-left flex gap-4 items-center justify-between">
                      <div className="flex-1 min-w-0">
                        <p className="text-[#1a0dab] dark:text-blue-400 text-sm font-medium leading-snug hover:underline cursor-pointer truncate">
                          {meta_title}
                        </p>
                        <div className="flex items-center text-xs text-[#006621] dark:text-emerald-400 mt-1 truncate">
                          {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${blogRoute}/${(blogSlugName || "").toLowerCase()}`}
                        </div>
                        <p
                          className="text-[#4d5156] dark:text-zinc-300 text-xs mt-1 leading-relaxed line-clamp-3"
                          dangerouslySetInnerHTML={{ __html: meta_description }}
                        ></p>
                      </div>
                      {meta_image && (
                        <div className="w-24 h-16 shrink-0 rounded-lg overflow-hidden border border-gray-100 dark:border-zinc-700 flex items-center justify-center bg-gray-50 dark:bg-zinc-900">
                          <img src={meta_image} className="w-full h-full object-contain" alt="Preview" />
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="w-full bg-gray-50 dark:bg-zinc-800/50 border border-gray-200 dark:border-zinc-700 rounded-xl p-4 text-left flex gap-4 items-center justify-between">
                      <div className="flex-1 min-w-0">
                        <p className="text-gray-400 dark:text-zinc-400 text-sm font-medium leading-snug truncate">
                          Example Blog Title
                        </p>
                        <div className="flex items-center text-xs text-gray-400 dark:text-zinc-500 mt-1 truncate">
                          yourdomain.com/blog/sample-blog
                        </div>
                        <p className="text-gray-400 dark:text-zinc-400 text-xs mt-1 leading-relaxed line-clamp-2">
                          This is a sample meta description. When you add a title and description, your search engine preview will appear here.
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                <div>
                  <AiTextGenerate
                    fieldLabel={t("lang_meta_title") || "Meta Title"}
                    label={t("lang_get_meta_title") || "Generate"}
                    tooltip={t("lang_meta_tooltip", { type: "title" })}
                    onGenerate={() => generateMetaData(secondDescription || title, "title")}
                  />
                  <InputComponent
                    type="text"
                    id="meta_title"
                    name="meta_title"
                    value={meta_title}
                    onChange={(e) => {
                      setIsMetaTitleCustom(Boolean(e.target.value));
                      setMeta((prev) => ({ ...prev, [e.target.name]: e.target.value }));
                    }}
                    placeholder="Meta title..."
                  />
                  <div className="flex w-full justify-end mt-1">
                    <p
                      className={`text-[11px] ${(meta_title?.length || 0) > 60
                        ? "text-red-500 font-semibold"
                        : "text-gray-400 dark:text-zinc-500"
                        }`}
                    >
                      {meta_title?.length || 0}/60
                    </p>
                  </div>
                </div>

                <div>
                  <AiTextGenerate
                    fieldLabel={t("lang_meta_description") || "Meta Description"}
                    label={t("lang_get_meta_description") || "Generate"}
                    tooltip={t("lang_meta_tooltip", { type: "description" })}
                    onGenerate={() => generateMetaData(secondDescription || description, "description")}
                  />
                  <textarea
                    className="w-full h-24 block px-3 py-2 border border-gray-200 dark:border-zinc-700 rounded-lg focus:outline-none focus:border-gray-400 dark:focus:border-zinc-500 bg-white dark:bg-zinc-800 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-zinc-500 text-xs"
                    id="meta_description"
                    name="meta_description"
                    value={(meta_description || "").replace(/<[^>]+>/g, "")}
                    onChange={(e) => setMeta({ ...meta, meta_description: e.target.value })}
                    placeholder="Meta description..."
                  />
                  <div className="flex w-full justify-end mt-1">
                    <p
                      className={`text-[11px] ${metaDescLength > 160 ? "text-red-500 font-semibold" : "text-gray-400 dark:text-zinc-500"
                        }`}
                    >
                      {metaDescLength}/160 words
                    </p>
                  </div>
                </div>

                <div>
                  <label htmlFor="meta_image">
                    <p className="text-xs font-semibold text-gray-700 dark:text-zinc-300 mb-1">
                      {t("lang_meta_image") || "OG Image"}
                    </p>
                  </label>
                  <ImageUploader
                    alreadyImage={meta_image}
                    handleSetImage={(val) => setMeta((prev) => ({ ...prev, meta_image: val }))}
                    folder="og"
                    format="image"
                    removeImages={() => setMeta((prev) => ({ ...prev, meta_image: "" }))}
                  />
                </div>
              </div>

              {/* Card 4: Custom Fields */}
              {isCustomField && (
                <UpdateCustomMetaField
                  meta_fields={meta_fields}
                  setmeta_fields={setmeta_fields}
                  heading="blog"
                  errors={customFieldErrors}
                  setErrors={setCustomFieldErrors}
                  metaFieldData={customFieldList}
                  setMetaFieldData={setCustomFieldList}
                />
              )}
            </form>
          </div>
        </div>
      </div>

      {/* Sticky Bottom Action Bar */}
      <div className="flex items-center justify-between w-full border-t border-gray-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-3.5 px-6 shrink-0">
        <button
          type="button"
          onClick={handleBulkEditCancel}
          className="flex items-center text-xs font-medium text-gray-500 dark:text-zinc-400 hover:text-gray-900 dark:hover:text-white transition-colors gap-1 cursor-pointer"
        >
          ← cancel
        </button>

        <div className="flex items-center gap-2">
          <ButtonComponent
            variant='primary'
            size='sm'
            loading={btnLoading}
            disabled={modifiedCount === 0 || btnLoading}
            onClick={handleBulkUpdate}
          >
            {modifiedCount > 0 ? `Save Changes (${modifiedCount})` : 'Save Changes'}
          </ButtonComponent>
        </div>
      </div>

      <Dialog
        open={isSchedule}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setIsSchedule(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="w-full sm:w-[450px] p-6 rounded-[12px] bg-white dark:bg-zinc-900 text-gray-900 dark:text-zinc-100 shadow-xl flex flex-col">
          <div className="flex items-center justify-between pb-3 mb-4 border-b border-gray-200 dark:border-zinc-800">
            <h5 className="text-base font-semibold text-gray-900 dark:text-white m-0">
              {t("lang_Set_Publish_Date") || "Set publish date"}
            </h5>
            <button
              type="button"
              onClick={() => setIsSchedule(false)}
              className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 p-1 rounded-md transition-colors border-none bg-transparent cursor-pointer"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="relative">
              <input
                type="text"
                readOnly
                value={
                  scheduleTimeDate
                    ? new Date(scheduleTimeDate).toLocaleDateString("en-US", {
                        month: "long",
                        day: "numeric",
                        year: "numeric",
                      }) +
                      " " +
                      new Date(scheduleTimeDate).toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })
                    : ""
                }
                placeholder={t("lang_Select_Date_Time") || "Select date & time"}
                className="w-full px-3 py-2 border border-gray-200 dark:border-zinc-700 rounded-lg text-sm bg-gray-50 dark:bg-zinc-800 text-gray-900 dark:text-white pr-10 focus:outline-none"
              />
              <CalendarFill className="absolute right-3 top-3 w-4 h-4 text-gray-400" />
            </div>

            <div className="w-full min-h-[290px] custom-datepicker-inline flex justify-center">
              <div className="relative w-full flex justify-center">
                <DatePicker
                  className={`${scheduleTimeDate ? "bold-date" : ""} w-full px-3 py-2 border border-gray-200 dark:border-zinc-700 rounded-[6px] focus:outline-none focus:border-gray-400 bg-white dark:bg-zinc-800 text-gray-900 dark:text-white`}
                  showTimeSelect
                  inline
                  selected={scheduleTimeDate ? new Date(scheduleTimeDate) : null}
                  onChange={(date) => setScheduleTimeDate(date)}
                  dateFormat="MMMM d, yyyy h:mm aa"
                />
              </div>
            </div>

            <div className="pt-2">
              <ButtonComponent
                variant="primary"
                type="button"
                onClick={() => setIsSchedule(false)}
              >
                {t("lang_Done") || "Done"}
              </ButtonComponent>
            </div>
          </div>
        </div>
      </Dialog>

      <UnsavedChangesModal
        open={showUnsavedModal}
        onStay={handleStay}
        onLeave={handleConfirmLeave}
      />
    </div>
  );
};

export default BulkEditBlog;
